/* tslint:disable */
/* eslint-disable */
/**
 * Datixo API
 * API endpoints for communication with Datixo.
 *
 * The version of the OpenAPI document: v1.0.0
 * Contact: api@datixo.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ProductAssortmentGroupData } from './ProductAssortmentGroupData';
import {
    ProductAssortmentGroupDataFromJSON,
    ProductAssortmentGroupDataFromJSONTyped,
    ProductAssortmentGroupDataToJSON,
    ProductAssortmentGroupDataToJSONTyped,
} from './ProductAssortmentGroupData';

/**
 * 
 * @export
 * @interface ProductAssortmentSummaryData
 */
export interface ProductAssortmentSummaryData {
    /**
     * 
     * @type {number}
     * @memberof ProductAssortmentSummaryData
     */
    sourceTotalItems?: number;
    /**
     * 
     * @type {number}
     * @memberof ProductAssortmentSummaryData
     */
    classifiedItems?: number;
    /**
     * 
     * @type {number}
     * @memberof ProductAssortmentSummaryData
     */
    totalValue?: number;
    /**
     * 
     * @type {Array<ProductAssortmentGroupData>}
     * @memberof ProductAssortmentSummaryData
     */
    groups?: Array<ProductAssortmentGroupData>;
}

/**
 * Check if a given object implements the ProductAssortmentSummaryData interface.
 */
export function instanceOfProductAssortmentSummaryData(value: object): value is ProductAssortmentSummaryData {
    return true;
}

export function ProductAssortmentSummaryDataFromJSON(json: any): ProductAssortmentSummaryData {
    return ProductAssortmentSummaryDataFromJSONTyped(json, false);
}

export function ProductAssortmentSummaryDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProductAssortmentSummaryData {
    if (json == null) {
        return json;
    }
    return {
        
        'sourceTotalItems': json['sourceTotalItems'] == null ? undefined : json['sourceTotalItems'],
        'classifiedItems': json['classifiedItems'] == null ? undefined : json['classifiedItems'],
        'totalValue': json['totalValue'] == null ? undefined : json['totalValue'],
        'groups': json['groups'] == null ? undefined : ((json['groups'] as Array<any>).map(ProductAssortmentGroupDataFromJSON)),
    };
}

export function ProductAssortmentSummaryDataToJSON(json: any): ProductAssortmentSummaryData {
    return ProductAssortmentSummaryDataToJSONTyped(json, false);
}

export function ProductAssortmentSummaryDataToJSONTyped(value?: ProductAssortmentSummaryData | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'sourceTotalItems': value['sourceTotalItems'],
        'classifiedItems': value['classifiedItems'],
        'totalValue': value['totalValue'],
        'groups': value['groups'] == null ? undefined : ((value['groups'] as Array<any>).map(ProductAssortmentGroupDataToJSON)),
    };
}

